// @ts-nocheck
import React, { createRef } from "react";
import InputLabel from "../../../../../base/basicComponents/inputLabel";
import NormalSelect from "../../../../../base/basicComponents/select";
import { FileUploadDragger } from "../../../../../base/basicComponents/uploadFile";
import { NormalTextArea } from "../../../../../base/basicComponents/input";
import { signOffSelectValues } from "../../../../publicDictionaryValues";
import styles from "../styles/index.module.scss";
import BaseAlignWithClient from "../baseAlignWithClientSection";
import AdditionalAttachment from "../additionalAttachmentSection";
import { isArray } from "lodash";

export default class ReadOnlyAlignWithClient extends BaseAlignWithClient {
  attachmentRef = createRef();
  attachmentInputRef = createRef();

  componentDidMount() {
    if (this.attachmentRef.current !== null) {
      // @ts-ignore
      this.attachmentRef.current.loadFiles();
    }
  }

  render() {
    const { selectValue, reason, isReasonError, isComplete, fileIdList, fileNameList } = this.state;

    const {
      loadingProps: { openLoading, hideLoading, updateFileNumLoading },
      additionalFiles,
      additionalComment,
      canUploadAttachment,
      submitIds,
      processStatus,
      triggerProcess,
    } = this.props;

    const hasFiles = isArray(additionalFiles) && additionalFiles.length > 0;
    const isProcessStatusApproved = processStatus === "Active" || processStatus === "Archived";
    const url = new URL(window.location.href);
    const returnUrl = url.searchParams.get("returnUrl");
    const isFromChangeHistory = !!returnUrl;

    const isShowAdditionalPart =
      hasFiles || (isProcessStatusApproved && (isFromChangeHistory ? canUploadAttachment : false));
    return (
      <div className={styles.alignWithClientContainer}>
        <div className="flex items-center gap-x-[18px]">
          <div className={styles.awcTitle}>Align with Client</div>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="!underline text-[#2F61B0] font-medium leading-[18px] underline-offset-4"
            href={triggerProcess}
            data-testid="sign-off-trigger-process-link-readonly"
          >
            Click here to review the trigger process
          </a>
        </div>
        <div className={styles.awcFieldDiv}>
          <div className={styles.awcSelect}>
            <InputLabel text="Aligned with Client?" />
            {/* @ts-ignore */}
            <NormalSelect
              testid="sign-off-aligned-with-client-select"
              value={selectValue}
              optionList={this.optionList}
              disabled={true}
            />
          </div>
          <div className={styles.awcBottomDiv}>
            <div className={styles.attachEmailDiv}>
              <InputLabel text="Attach Email" required={selectValue === signOffSelectValues.Yes} />
              {/* @ts-ignore */}
              <FileUploadDragger
                ref={this.attachmentRef}
                className={styles.fileDragger}
                fileInputRef={this.attachmentInputRef}
                isShowBox={true}
                isMultiple={true}
                isShowDeleteBtn={!isComplete}
                openLoading={openLoading}
                hideLoading={hideLoading}
                updateFileNumLoading={updateFileNumLoading}
                fileIds={fileIdList}
                fileNames={fileNameList}
                isDownload={true}
                fileNameType="link"
              />
            </div>
            <div className={styles.reasonDiv}>
              <InputLabel text="Reason" required={selectValue === signOffSelectValues.NoNeed} />
              <NormalTextArea
                testid="sign-off-aligned-reason-textarea"
                value={reason}
                width="44.75"
                className="reasonInput"
                status={isReasonError ? "error" : ""}
                disabled={true}
              />
            </div>
          </div>
          {isShowAdditionalPart && (
            <AdditionalAttachment
              openLoading={openLoading}
              hideLoading={hideLoading}
              additionalFiles={additionalFiles}
              additionalComment={additionalComment}
              submitIds={submitIds}
              updateFileNumLoading={updateFileNumLoading}
            />
          )}
        </div>
      </div>
    );
  }
}
